import { AnswerProgress, PlayingAudioIcon, SectionChevron, SectionDivider, SectionHeader, SectionPanel, SectionTitle, SectionTitleText } from '../submission-section-summary-v3.styles';
import { SectionSummaryQuestionItems } from './section-summary-question-items.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionSummaryPanel = function SectionSummaryPanel(_ref) {
  var sectionItem = _ref.sectionItem,
      isLoadingQuestions = _ref.isLoadingQuestions,
      isCollapsible = _ref.isCollapsible,
      label = _ref.label,
      onToggleSection = _ref.onToggleSection,
      onSelectQuestion = _ref.onSelectQuestion;
  var contentId = "section-summary-content-".concat(sectionItem.id);

  var toggleSection = function toggleSection() {
    return onToggleSection(sectionItem.id);
  };

  var onKeyDown = function onKeyDown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    toggleSection();
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(SectionPanel, {
      children: [/*#__PURE__*/_jsxs(SectionTitle, {
        $isExpanded: sectionItem.isExpanded,
        $isCollapsible: isCollapsible,
        onClick: isCollapsible ? toggleSection : undefined,
        onKeyDown: isCollapsible ? onKeyDown : undefined,
        role: isCollapsible ? 'button' : undefined,
        tabIndex: isCollapsible ? 0 : undefined,
        "aria-expanded": isCollapsible ? sectionItem.isExpanded : undefined,
        "aria-controls": isCollapsible ? contentId : undefined,
        children: [/*#__PURE__*/_jsxs(SectionHeader, {
          children: [/*#__PURE__*/_jsx(SectionChevron, {
            $isExpanded: sectionItem.isExpanded
          }), /*#__PURE__*/_jsx(SectionTitleText, {
            children: sectionItem.title
          }), sectionItem.isAudioPlaying && /*#__PURE__*/_jsx(PlayingAudioIcon, {})]
        }), /*#__PURE__*/_jsx(AnswerProgress, {
          children: "".concat(label.answered, " ").concat(sectionItem.answeredCount, "/").concat(sectionItem.totalQuestions)
        })]
      }), sectionItem.isExpanded && /*#__PURE__*/_jsx("div", {
        id: contentId,
        children: /*#__PURE__*/_jsx(SectionSummaryQuestionItems, {
          sectionIndex: sectionItem.index,
          questionItems: sectionItem.questionItems,
          isLoading: isLoadingQuestions,
          label: label,
          onSelectQuestion: onSelectQuestion
        })
      })]
    }), /*#__PURE__*/_jsx(SectionDivider, {})]
  });
};